import {
  getFirestore,
  collection,
  getDocs,
  getDoc,
  setDoc,
  doc,
  deleteDoc
} from "firebase/firestore/lite";
import { app } from "./main";
import { getResultaoById } from "./resultadosVoley";

const db = getFirestore(app);

export const getAllEquipos = async () => {
  const equiposCol = collection(db, "equiposVoley");
  const equiposSnapshot = await getDocs(equiposCol);
  const equiposList = equiposSnapshot.docs.map((doc) => doc.data());
  return equiposList;
};

export const addEquipo = async (data) => {
  console.log(data.id);
  try {
    await setDoc(doc(db, "equiposVoley", data.id.toString()), data);
    alert("Se agregó el equipo correctamente. ");
  } catch (e) {
    alert(`Error guardando el equipo: ${e}` );
  }
};

export const getEquipo = async (id) => {
  const docRef = doc(db, "equiposVoley", id.toString());
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data();
  } else {
    return alert("No se encontró ningún equipo");
  }
};

export const deleteEquipo = async (equipoId) => {
  try {
      const docRef = doc(db, "equiposVoley", equipoId.toString());
      await deleteDoc(docRef)
      alert("El equipo se eliminó correctamente")
  } catch (error) {
    alert(error)
  }
}


export const updateEquipos = async (resultado, isEditing) => {
  
  if(isEditing){
    const resultadoAnterior = await getResultaoById(resultado.id);
    await revertirPuntos(resultadoAnterior)
  } 

  let equipoLocal = await getEquipo(resultado.equipo_local_id)
  let equipoVisitante = await getEquipo(resultado.equipo_visitante_id)
  await seteoPuntos(resultado, equipoLocal, equipoVisitante)
};


const seteoPuntos = async (resultado, equipoLocal, equipoVisitante) => {
    const { sets_local, sets_visitante } = resultado;

  // Clonamos los objetos para no mutar los originales
  const local = { ...equipoLocal };
  const visitante = { ...equipoVisitante };

  // 🔹 Actualizamos sets ganados/perdidos
  local.sets_ganados += sets_local;
  local.sets_perdidos += sets_visitante;
  visitante.sets_ganados += sets_visitante;
  visitante.sets_perdidos += sets_local;

  // 🔹 Actualizamos puntos a favor / en contra
  let puntosFavorLocal = 0;
  let puntosFavorVisitante = 0;

  for (let i = 1; i <= 5; i++) {
    const sl = parseInt(resultado[`set_local_${i}`]);
    const sv = parseInt(resultado[`set_visitante_${i}`]);
    if (!isNaN(sl) && !isNaN(sv)) {
      puntosFavorLocal += sl;
      puntosFavorVisitante += sv;
    }
  }

  local.puntos_favor += puntosFavorLocal;
  local.puntos_contra += puntosFavorVisitante;
  visitante.puntos_favor += puntosFavorVisitante;
  visitante.puntos_contra += puntosFavorLocal;

  // 🔹 Determinar ganador y asignar puntos
  if (sets_local > sets_visitante) {
    // Gana local
    local.partidos_ganados += 1;
    visitante.partidos_perdidos += 1;

    if (sets_local === 2 && sets_visitante === 0) {
      local.puntos += 3;
      visitante.puntos += 0;
    } else if (sets_local === 2 && sets_visitante === 1) {
      local.puntos += 2;
      visitante.puntos += 1;
    }
  } else if (sets_visitante > sets_local) {
    // Gana visitante
    visitante.partidos_ganados += 1;
    local.partidos_perdidos += 1;

    if (sets_visitante === 2 && sets_local === 0) {
      visitante.puntos += 3;
      local.puntos += 0;
    } else if (sets_visitante === 2 && sets_local === 1) {
      visitante.puntos += 2;
      local.puntos += 1;
    }
  }

  await setDoc(doc(db, "equiposVoley", local.id.toString()), local);
  await setDoc(doc(db, "equiposVoley", visitante.id.toString()), visitante);
}

const revertirPuntos = async (resultado) => {
  let equipoLocal = await getEquipo(resultado.equipo_local_id)
  let equipoVisitante = await getEquipo(resultado.equipo_visitante_id)
  const { sets_local, sets_visitante } = resultado;

  let ganador

  // Determinar ganador y perdedor del resultado anterior
  if (sets_local > sets_visitante) {
    ganador = "local";
  } else {
    ganador = "visitante";
  } 

  // Revertir sets
  equipoLocal.sets_ganados -= sets_local;
  equipoLocal.sets_perdidos -= sets_visitante;
  equipoLocal.puntos_favor -= (parseInt(resultado.set_local_1) + parseInt(resultado.set_local_2) + parseInt(resultado.set_local_3) )
  equipoLocal.puntos_contra -= (parseInt(resultado.set_visitante_1) + parseInt(resultado.set_visitante_2) -+ parseInt(resultado.set_visitante_3) )
  equipoVisitante.sets_ganados -= sets_visitante;
  equipoVisitante.sets_perdidos -= sets_local;
  equipoVisitante.puntos_contra -= (parseInt(resultado.set_local_1) + parseInt(resultado.set_local_2) + parseInt(resultado.set_local_3) )
  equipoVisitante.puntos_favor -= (parseInt(resultado.set_visitante_1) + parseInt(resultado.set_visitante_2) + parseInt(resultado.set_visitante_3) )

  // Revertir puntos de tabla
  if (ganador === "local") {
    if (sets_local === 2 && sets_visitante === 0) {
      equipoLocal.puntos -= 3;
    } else if (sets_local === 2 && sets_visitante === 1) {
      equipoLocal.puntos -= 2;
      equipoVisitante.puntos -= 1
    }
    equipoLocal.partidos_ganados -= 1;
    equipoVisitante.partidos_perdidos -= 1;
  } else if (ganador === "visitante") {
    if (sets_visitante === 2 && sets_local === 0) {
      equipoVisitante.puntos -= 3;
    } else if (sets_visitante === 2 && sets_local === 1) {
      equipoVisitante.puntos -= 2;
      equipoLocal.puntos -= 1
    }
    equipoVisitante.partidos_ganados -= 1;
    equipoLocal.partidos_perdidos -= 1;
  }

  // Asegurar que nada quede negativo
  equipoLocal.puntos = Math.max(equipoLocal.puntos, 0);
  equipoVisitante.puntos = Math.max(equipoVisitante.puntos, 0);
  equipoLocal.sets_ganados = Math.max(equipoLocal.sets_ganados, 0);
  equipoLocal.sets_perdidos = Math.max(equipoLocal.sets_perdidos, 0);
  equipoVisitante.sets_ganados = Math.max(equipoVisitante.sets_ganados, 0);
  equipoVisitante.sets_perdidos = Math.max(equipoVisitante.sets_perdidos, 0);

  await setDoc(doc(db, "equiposVoley", equipoLocal.id.toString()), equipoLocal);
  await setDoc(doc(db, "equiposVoley", equipoVisitante.id.toString()), equipoVisitante);
}

// const revertirPuntosViejo = async (resultado) => {
//   const resultadoAnterior = await getResultaoById(resultado.id);

//   const puntos_local = parseInt(resultadoAnterior.puntos_local);
//   const puntos_visitante = parseInt(resultadoAnterior.puntos_visitante);
//   const puntos_ganador =
//     puntos_local > puntos_visitante ? puntos_local : puntos_visitante;
//   const puntos_perdedor =
//     puntos_local < puntos_visitante ? puntos_local : puntos_visitante;

//     let ganadorAnteriorId
//     let perdedorAnteriorId

//     if (parseInt(resultadoAnterior.puntos_local) > parseInt(resultadoAnterior.puntos_visitante)) {
//       ganadorAnteriorId = resultadoAnterior.equipo_local_id
//       perdedorAnteriorId = resultadoAnterior.equipo_visitante_id
//     } else {
//       ganadorAnteriorId = resultadoAnterior.equipo_visitante_id
//       perdedorAnteriorId = resultadoAnterior.equipo_local_id
//     }

//     const equipoGanadorAnterior = await getEquipo(ganadorAnteriorId)
//     const newPuntosGanador = equipoGanadorAnterior;
//     newPuntosGanador.puntos = equipoGanadorAnterior.puntos - 2;
//     newPuntosGanador.puntos_favor = equipoGanadorAnterior.puntos_favor - parseInt(puntos_ganador);
//     newPuntosGanador.puntos_contra =
//     equipoGanadorAnterior.puntos_contra - parseInt(puntos_perdedor);
//     newPuntosGanador.partidos_ganados = equipoGanadorAnterior.partidos_ganados - 1;
//     newPuntosGanador.partidos_perdidos = equipoGanadorAnterior.partidos_perdidos;
//     await setDoc(doc(db, "equiposVoley", equipoGanadorAnterior.id.toString()), newPuntosGanador);

//     const equipoPerdedorAnterior = await getEquipo(perdedorAnteriorId)
//     const newPuntosPerdedor = equipoPerdedorAnterior;
//     newPuntosPerdedor.puntos = equipoPerdedorAnterior.puntos - 1;
//     newPuntosPerdedor.puntos_favor = equipoPerdedorAnterior.puntos_favor - parseInt(puntos_perdedor);
//     newPuntosPerdedor.puntos_contra = equipoPerdedorAnterior.puntos_contra - parseInt(puntos_ganador);
//     newPuntosPerdedor.partidos_ganados = equipoPerdedorAnterior.partidos_ganados;
//     newPuntosPerdedor.partidos_perdidos = equipoPerdedorAnterior.partidos_perdidos - 1;
//     await setDoc(doc(db, "equiposVoley", equipoPerdedorAnterior.id.toString()), newPuntosPerdedor);
//   }
